import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import LandingPage from "@/pages/LandingPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import CasesPage from "@/pages/admin/CasesPage";
import CaseDetailPage from "@/pages/admin/CaseDetailPage";
import NewCasePage from "@/pages/admin/NewCasePage";
import ContactsPage from "@/pages/admin/ContactsPage";
import ContactDetailPage from "@/pages/admin/ContactDetailPage";
import OrganizationsPage from "@/pages/admin/OrganizationsPage";
import OrganizationDetailPage from "@/pages/admin/OrganizationDetailPage";
import MentionsLegalesPage from "@/pages/MentionsLegalesPage";
import PolitiqueConfidentialitePage from "@/pages/PolitiqueConfidentialitePage";
import CookiesPage from "@/pages/CookiesPage";
import CGVPage from "@/pages/CGVPage";
import ReclamationsPage from "@/pages/ReclamationsPage";
import PlanDuSitePage from "@/pages/PlanDuSitePage";
import NotFoundPage from "@/pages/NotFoundPage";
import SEOResolverPage from "@/pages/seo/SEOResolverPage";
import DashboardPage from "@/pages/admin/DashboardPage";
import QuotesPage from "@/pages/admin/QuotesPage";
import QuoteEditorPage from "@/pages/admin/QuoteEditorPage";
import InventoryPage from "@/pages/admin/InventoryPage";
import SettingsPage from "@/pages/admin/SettingsPage";
import ClientPortalPage from "@/pages/ClientPortalPage";
import { VehiclesPage, TeamsAndUsersPage, TasksPage, IncidentsPage } from "@/pages/admin/OpsListsPages";
import { PlanningPage, MissionsPage, MissionDetailPage, FieldPage } from "@/pages/admin/PlanningMissionsPages";
import { PaymentsPage, InvoicesPage, DocumentsPage } from "@/pages/admin/FinancePages";
import { CommunicationsPage, AutomationsPage, AuditLogPage } from "@/pages/admin/CommsPages";

function App() {
  return (
    <div className="App">
      <AdminAuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialitePage />} />
            <Route path="/politique-cookies" element={<CookiesPage />} />
            <Route path="/conditions-generales" element={<CGVPage />} />
            <Route path="/reclamations" element={<ReclamationsPage />} />
            <Route path="/plan-du-site" element={<PlanDuSitePage />} />
            <Route path="/admin" element={<CasesPage />} />
            <Route path="/admin/tableau-de-bord" element={<DashboardPage />} />
            <Route path="/admin/dossiers/nouveau" element={<NewCasePage />} />
            <Route path="/admin/dossiers/:id" element={<CaseDetailPage />} />
            <Route path="/admin/dossiers/:id/inventaire" element={<InventoryPage />} />
            <Route path="/admin/contacts" element={<ContactsPage />} />
            <Route path="/admin/contacts/:id" element={<ContactDetailPage />} />
            <Route path="/admin/organisations" element={<OrganizationsPage />} />
            <Route path="/admin/organisations/:id" element={<OrganizationDetailPage />} />
            <Route path="/admin/devis" element={<QuotesPage />} />
            <Route path="/admin/devis/:id" element={<QuoteEditorPage />} />
            <Route path="/admin/planning" element={<PlanningPage />} />
            <Route path="/admin/missions" element={<MissionsPage />} />
            <Route path="/admin/missions/:id" element={<MissionDetailPage />} />
            <Route path="/admin/terrain" element={<FieldPage />} />
            <Route path="/admin/taches" element={<TasksPage />} />
            <Route path="/admin/incidents" element={<IncidentsPage />} />
            <Route path="/admin/vehicules" element={<VehiclesPage />} />
            <Route path="/admin/equipes" element={<TeamsAndUsersPage />} />
            <Route path="/admin/paiements" element={<PaymentsPage />} />
            <Route path="/admin/factures" element={<InvoicesPage />} />
            <Route path="/admin/documents" element={<DocumentsPage />} />
            <Route path="/admin/communications" element={<CommunicationsPage />} />
            <Route path="/admin/automatisations" element={<AutomationsPage />} />
            <Route path="/admin/journal" element={<AuditLogPage />} />
            <Route path="/admin/parametres" element={<SettingsPage />} />
            <Route path="/suivi/:token" element={<ClientPortalPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="/:slug" element={<SEOResolverPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AdminAuthProvider>
    </div>
  );
}

export default App;
